export default {"src":"/_next/static/media/samoa.8c1de7fc.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};